// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__6C2Dq","footer":"NavbarSimple_footer__EZSBk","link":"NavbarSimple_link__rGOvM","linkIcon":"NavbarSimple_linkIcon__mtaWx"};